export function Contacts() {
  return (
    <div>
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Contacts
          </h2>
        </div>
        <div className="mt-4 flex md:mt-0 md:ml-4">
          <button className="btn btn-primary">
            Add Contact
          </button>
        </div>
      </div>

      <div className="mt-8">
        <div className="card">
          <div className="card-body">
            <div className="text-center py-12">
              <div className="w-12 h-12 mx-auto bg-gray-100 rounded-full flex items-center justify-center">
                <span className="text-gray-400 text-lg">👥</span>
              </div>
              <h3 className="mt-4 text-lg font-medium text-gray-900">
                No contacts yet
              </h3>
              <p className="mt-2 text-sm text-gray-500">
                Get started by adding your first contact or importing from Gmail.
              </p>
              <div className="mt-6 flex justify-center space-x-3">
                <button className="btn btn-primary">
                  Add Contact
                </button>
                <button className="btn btn-outline">
                  Import from Gmail
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
